import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ImmomioIconName } from '@resident-nx/shared';
import { CardWebComponent, IconWebComponent } from '@resident-nx/web/ui';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'rs-web-file-upload-button',
  imports: [CardWebComponent, IconWebComponent, TranslateModule],
  templateUrl: './file-upload-button.component.html',
  styleUrl: './file-upload-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileUploadButtonComponent {
  protected readonly ImmomioIconName = ImmomioIconName;

  label = input('upload_file_l');
}
